module.exports = __webpack_public_path__ + "montserrat-semibold-webfont.5aac3dc23f11aa81e362.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-semibold-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-semibold-webfont.woff
// module chunks = styles